<script setup lang="ts">
import { computed } from 'vue'
import RichTextRenderer from '~/components/utils/RichTextRenderer.vue'
import FullscreenContent from '~/components/utils/FullscreenContent.vue'
import CopyrightButton from '~/components/utils/CopyrightButton.vue'

const { width, height, focalPointX, focalPointY } = defineProps<{
  src: string
  alt: string
  caption: string
  copyright: string
  width?: number
  height?: number
  focalPointX?: number
  focalPointY?: number
}>()

const objectPosition = computed(() => {
  if (!focalPointX || !focalPointY || !width || !height) {
    return undefined
  }
  const xPercent = Math.round((focalPointX / width) * 100)
  const yPercent = Math.round((focalPointY / height) * 100)
  return `${xPercent}% ${yPercent}%`
})
</script>

<template>
  <FullscreenContent class="not-prose text-black">
    <template #default="{ isFullscreen }">
      <img
        :src
        :alt="alt || ''"
        :style="!isFullscreen && objectPosition ? { objectPosition } : undefined"
        class="col-start-1 row-start-1 size-full"
        :class="isFullscreen ? 'object-scale-down p-4 place-self-center' : 'object-cover'"
      >

      <div
        v-if="caption.trim()"
        class="bg-white p-4"
        data-ignore-tts
      >
        <RichTextRenderer :text="caption" />
      </div>

      <CopyrightButton
        v-if="copyright.trim()"
        class="z-10 col-start-1 row-start-1 place-self-end"
        :copyright
      />
    </template>
  </FullscreenContent>
</template>
